export default "__VITE_ASSET__CAYgP3S6__"